import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { propBool, propFunc, propShape, } from '../../../../../../../helpers/custom-prop-types';
const OfferCheckBox = (props) => {
    const { checked, isDisabled, onChange: onChangeRaw, viewRequest } = props;
    const onChange = useCallback((e) => {
        onChangeRaw(viewRequest, e);
    }, [onChangeRaw, viewRequest]);
    return (_jsx("label", Object.assign({ className: 'offer_checkbox_box' }, { children: !isDisabled && (_jsxs(_Fragment, { children: [_jsx("input", { checked: checked, className: 'offer_checkbox', onChange: onChange, type: 'checkbox', value: viewRequest.id }), _jsx("div", Object.assign({ className: 'offer_checkbox_view' }, { children: _jsx("i", { className: 'material-icons check' }) }))] })) })));
};
OfferCheckBox.propTypes = {
    checked: propBool().isRequired,
    isDisabled: propBool().isRequired,
    onChange: propFunc().isRequired,
    viewRequest: propShape().isRequired,
};
export default OfferCheckBox;
